import { useStorage } from '@vueuse/core'
import { useSelectedCustomer } from '@/core/composables/useSelectedCustomer'

const customerCart = useStorage('customer-cart', {})
const anonCart = useStorage('anon-cart', true)
const customer = useSelectedCustomer()

const wasLoggedIn = computed(() => {
  return customer.value && anonCart.value
})

const wasLoggedOut = computed(() => {
  return !customer.value && !anonCart.value
})

export function useCustomerCartState() {
  if (wasLoggedIn.value) {
    anonCart.value = false
  }

  if (wasLoggedOut.value) {
    anonCart.value = true
    customerCart.value = {}
  }

  return customerCart.value
}
